import { useEffect, useState } from 'react'

/** SSR-safe media query: false on the server and first render, then the real value after mount. */
export const useMediaQuery = (query: string): boolean => {
    const [matches, setMatches] = useState(false)

    useEffect(() => {
        const media = window.matchMedia(query)
        const update = () => setMatches(media.matches)

        update()
        media.addEventListener('change', update)

        return () => media.removeEventListener('change', update)
    }, [query])

    return matches
}

/** True when the user asked the system for reduced motion (false until mounted). */
export const useReducedMotion = (): boolean => useMediaQuery('(prefers-reduced-motion: reduce)')
